import moment from 'moment';

export const isToday = (date: string): boolean => {
  if (!date || !moment(date).isValid()) return false;
  return moment(date).isSame(moment(), 'day');
};

export const isValidDate = (date: string): boolean => {
  return !!date && moment(date).isValid();
};

export const formatDate = (date: string): string | null => {
  if (!isValidDate(date)) {
    return null;
  }

  const momentDate = moment(date);
  const time = momentDate.format('h:mm A');
  
  // Get the timezone from the browser
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezoneAbbr = new Intl.DateTimeFormat('en', { timeZoneName: 'short' })
    .formatToParts(new Date())
    .find(part => part.type === 'timeZoneName')?.value || '';
  
  if (isToday(date)) {
    return `Today, ${time} ${timezoneAbbr}`;
  }
  return `${momentDate.format('MMM DD, YYYY')}, ${time} ${timezoneAbbr}`;
}; 
